"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _components = require("@quarkly/components");

var _widgets = require("@quarkly/widgets");

var _props = require("./props");

var _ComponentNotice = _interopRequireDefault(require("../ComponentNotice"));

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Design styles differ 50/50
// Brought out separately, so that there is less duplication


var getContentStyles = function getContentStyles(_ref) {
  var _baseStyles, _open, _closed, _objectSpread2, _objectSpread3, _objectSpread6, _objectSpread7;

  var breakpoint = _ref.breakpoint,
      menuPosition = _ref.menuPosition,
      animDuration = _ref.animDuration,
      animFunction = _ref.animFunction,
      isNear = _ref.isNear;
  var baseStyles = (_baseStyles = {
    padding: isNear ? '16px' : '48px 16px 24px',
    width: '100%',
    'align-items': 'center',
    'justify-content': 'space-between',
    'flex-direction': 'row'
  }, _defineProperty(_baseStyles, "".concat(breakpoint, "-width"), 'initial'), _defineProperty(_baseStyles, "".concat(breakpoint, "-min-width"), '280px'), _defineProperty(_baseStyles, "".concat(breakpoint, "-min-height"), '32px'), _defineProperty(_baseStyles, "".concat(breakpoint, "-align-items"), 'flex-start'), _defineProperty(_baseStyles, "".concat(breakpoint, "-flex-direction"), 'column'), _defineProperty(_baseStyles, "".concat(breakpoint, "-box-shadow"), '--xxl'), _baseStyles);
  var animStyles = {
    appear: {
      open: (_open = {}, _defineProperty(_open, "".concat(breakpoint, "-transition"), "\n\t\t\t\t\tvisibility ".concat(animDuration, " step-start,\n\t\t\t\t\topacity ").concat(animDuration, " ").concat(animFunction, "\n\t\t\t\t")), _defineProperty(_open, "".concat(breakpoint, "-visibility"), 'visible'), _defineProperty(_open, "".concat(breakpoint, "-opacity"), '1'), _open),
      closed: (_closed = {}, _defineProperty(_closed, "".concat(breakpoint, "-transition"), "\n\t\t\t\t\tvisibility ".concat(animDuration, " step-end,\n\t\t\t\t\topacity ").concat(animDuration, " ").concat(animFunction, "\n\t\t\t\t")), _defineProperty(_closed, "".concat(breakpoint, "-visibility"), 'hidden'), _defineProperty(_closed, "".concat(breakpoint, "-opacity"), '0'), _closed)
    },
    shift: {
      base: _defineProperty({}, "".concat(breakpoint, "-transition"), "\n\t\t\t\t\ttransform ".concat(animDuration, " ").concat(animFunction, "\n\t\t\t\t"))
    }
  };

  switch (menuPosition) {
    case 'full':
      return {
        normal: _objectSpread(_objectSpread({}, baseStyles), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(breakpoint, "-top"), '0'), _defineProperty(_objectSpread2, "".concat(breakpoint, "-left"), '0'), _defineProperty(_objectSpread2, "".concat(breakpoint, "-width"), '100%'), _defineProperty(_objectSpread2, "".concat(breakpoint, "-height"), '100%'), _defineProperty(_objectSpread2, "".concat(breakpoint, "-position"), 'fixed'), _objectSpread2)),
        open: animStyles.appear.open,
        closed: animStyles.appear.closed
      };

    case 'left':
    case 'right':
      return {
        normal: _objectSpread(_objectSpread({}, baseStyles), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, "".concat(breakpoint, "-top"), '0'), _defineProperty(_objectSpread3, "".concat(breakpoint, "-").concat(menuPosition === 'left' ? 'right' : 'left'), '100%'), _defineProperty(_objectSpread3, "".concat(breakpoint, "-padding-top"), '38px'), _defineProperty(_objectSpread3, "".concat(breakpoint, "-width"), '280px'), _defineProperty(_objectSpread3, "".concat(breakpoint, "-height"), '100%'), _defineProperty(_objectSpread3, "".concat(breakpoint, "-position"), 'fixed'), _objectSpread3)),
        closed: _objectSpread(_objectSpread({}, animStyles.shift.base), {}, _defineProperty({}, "".concat(breakpoint, "-transform"), 'translateX(0)')),
        open: _objectSpread(_objectSpread({}, animStyles.shift.base), {}, _defineProperty({}, "".concat(breakpoint, "-transform"), "translateX(".concat(menuPosition === 'left' ? '100%' : '-100%', ")")))
      };

    case 'near':
      return {
        normal: _objectSpread(_objectSpread({}, baseStyles), {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, "".concat(breakpoint, "-top"), '100%'), _defineProperty(_objectSpread6, "".concat(breakpoint, "-right"), '0'), _defineProperty(_objectSpread6, "".concat(breakpoint, "-position"), 'absolute'), _objectSpread6)),
        open: animStyles.appear.open,
        closed: animStyles.appear.closed
      };

    case 'nearRight':
      return {
        normal: _objectSpread(_objectSpread({}, baseStyles), {}, (_objectSpread7 = {}, _defineProperty(_objectSpread7, "".concat(breakpoint, "-top"), '100%'), _defineProperty(_objectSpread7, "".concat(breakpoint, "-left"), '0'), _defineProperty(_objectSpread7, "".concat(breakpoint, "-position"), 'absolute'), _objectSpread7)),
        open: animStyles.appear.open,
        closed: animStyles.appear.closed
      };

    default:
      return {};
  }
}; // Get all styles by properties


var getStyles = function getStyles(_ref2) {
  var _Button, _Wrapper, _WrapperOpen, _WrapperClosed, _Overlay, _OverlayOpen, _OverlayClosed;

  var breakpoint = _ref2.breakpoint,
      menuPosition = _ref2.menuPosition,
      animDuration = _ref2.animDuration,
      animFunction = _ref2.animFunction,
      isNear = _ref2.isNear;
  return {
    Button: (_Button = {
      'padding-right': '3px',
      'min-height': '0',
      'align-items': 'center',
      'align-self': 'flex-end',
      'flex-direction': menuPosition === 'left' || menuPosition === 'nearRight' ? 'row-reverse' : 'row',
      position: 'relative',
      cursor: 'pointer',
      display: 'none'
    }, _defineProperty(_Button, "".concat(breakpoint, "-display"), 'inline-flex'), _defineProperty(_Button, "".concat(breakpoint, "-flex"), '0 0 auto'), _defineProperty(_Button, "".concat(breakpoint, "-z-index"), isNear ? '2' : '1'), _Button),
    'Button Text': {
      margin: '0 .35em 0 0',
      'font-size': '14px',
      'user-select': 'none'
    },
    Wrapper: (_Wrapper = {
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',
      'z-index': '1'
    }, _defineProperty(_Wrapper, "".concat(breakpoint, "-top"), '0'), _defineProperty(_Wrapper, "".concat(breakpoint, "-left"), '0'), _defineProperty(_Wrapper, "".concat(breakpoint, "-position"), isNear ? 'absolute' : 'fixed'), _Wrapper),
    'Wrapper :open': (_WrapperOpen = {}, _defineProperty(_WrapperOpen, "".concat(breakpoint, "-transition"), "visibility ".concat(animDuration, " step-start")), _defineProperty(_WrapperOpen, "".concat(breakpoint, "-visibility"), 'visible'), _WrapperOpen),
    'Wrapper :closed': (_WrapperClosed = {}, _defineProperty(_WrapperClosed, "".concat(breakpoint, "-transition"), "visibility ".concat(animDuration, " step-end")), _defineProperty(_WrapperClosed, "".concat(breakpoint, "-visibility"), 'hidden'), _WrapperClosed),
    Overlay: (_Overlay = {
      width: '100%',
      height: '100%',
      'background-color': isNear ? 'transparent' : 'rgba(0,0,0, .5)',
      position: 'relative',
      display: 'none',
      'z-index': '1'
    }, _defineProperty(_Overlay, "".concat(breakpoint, "-top"), '0'), _defineProperty(_Overlay, "".concat(breakpoint, "-left"), '0'), _defineProperty(_Overlay, "".concat(breakpoint, "-position"), 'fixed'), _defineProperty(_Overlay, "".concat(breakpoint, "-display"), 'block'), _Overlay),
    'Overlay :open': (_OverlayOpen = {}, _defineProperty(_OverlayOpen, "".concat(breakpoint, "-transition"), "\n      visibility ".concat(animDuration, " step-start,\n      opacity ").concat(animDuration, " ").concat(animFunction, "\n    ")), _defineProperty(_OverlayOpen, "".concat(breakpoint, "-visibility"), 'visible'), _defineProperty(_OverlayOpen, "".concat(breakpoint, "-opacity"), '1'), _OverlayOpen),
    'Overlay :closed': (_OverlayClosed = {}, _defineProperty(_OverlayClosed, "".concat(breakpoint, "-transition"), "\n      visibility ".concat(animDuration, " step-end,\n      opacity ").concat(animDuration, " ").concat(animFunction, "\n    ")), _defineProperty(_OverlayClosed, "".concat(breakpoint, "-visibility"), 'hidden'), _defineProperty(_OverlayClosed, "".concat(breakpoint, "-opacity"), '0'), _OverlayClosed),
    Content: _objectSpread({
      'max-width': '100vw',
      'max-height': '100vh',
      'background-color': 'white',
      'box-sizing': 'border-box',
      display: 'flex',
      'z-index': '2'
    }, getContentStyles({
      breakpoint: breakpoint,
      menuPosition: menuPosition,
      animDuration: animDuration,
      animFunction: animFunction,
      isNear: isNear
    }).normal),
    'Content :open': _objectSpread({}, getContentStyles({
      breakpoint: breakpoint,
      menuPosition: menuPosition,
      animDuration: animDuration,
      animFunction: animFunction,
      isNear: isNear
    }).open),
    'Content :closed': _objectSpread({}, getContentStyles({
      breakpoint: breakpoint,
      menuPosition: menuPosition,
      animDuration: animDuration,
      animFunction: animFunction,
      isNear: isNear
    }).closed),
    Children: {
      width: '100%'
    },
    Cross: _defineProperty({
      top: '16px',
      right: '16px',
      position: 'absolute',
      cursor: 'pointer',
      display: 'none'
    }, "".concat(breakpoint, "-display"), isNear ? 'none' : 'block')
  };
};

var MobileSidePanel = function MobileSidePanel(_ref3) {
  var breakpoint = _ref3.breakpoint,
      menuPosition = _ref3.menuPosition,
      animDuration = _ref3.animDuration,
      animFunction = _ref3.animFunction,
      props = _objectWithoutProperties(_ref3, ["breakpoint", "menuPosition", "animDuration", "animFunction"]);

  var _useOverrides = (0, _components.useOverrides)(props, _props.overrides),
      override = _useOverrides.override,
      children = _useOverrides.children,
      rest = _useOverrides.rest;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var isNear = (0, _react.useMemo)(function () {
    return menuPosition === 'near' || menuPosition === 'nearRight';
  }, [menuPosition]);
  var onToggle = (0, _react.useCallback)(function () {
    return setOpen(function (prev) {
      return !prev;
    });
  }, []);
  var onOpen = (0, _react.useCallback)(function () {
    return setOpen(true);
  }, []);
  var onClose = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, []);
  var isEmpty = (0, _react.useMemo)(function () {
    return (0, _utils.isEmptyChildren)(children);
  }, [children]);
  var styles = (0, _react.useMemo)(function () {
    return getStyles({
      breakpoint: breakpoint,
      menuPosition: menuPosition,
      animDuration: animDuration,
      animFunction: animFunction,
      isNear: isNear
    });
  }, [breakpoint, menuPosition, animDuration, animFunction, isNear]);
  var statusOpen = isOpen || isEmpty ? ':open' : ':closed';
  var statusButtonOpen = isNear && (isOpen || isEmpty) ? ':open' : ':closed';
  (0, _react.useEffect)(function () {
    setOpen(isOpen || isEmpty);
  }, [setOpen, isOpen, isEmpty]);
  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    flex: "1 1 auto",
    width: "100%",
    "min-width": "0px",
    "min-height": "0px",
    "align-items": "center",
    "justify-content": menuPosition === 'left' || menuPosition === 'nearRight' ? 'flex-start' : 'flex-end',
    position: "relative",
    display: "flex",
    "z-index": "5"
  }, rest), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    onPointerDown: isNear ? onToggle : onOpen
  }, styles.Button, override('Button', "Button ".concat(statusButtonOpen))), /*#__PURE__*/_react["default"].createElement(_widgets.Text, _extends({}, styles['Button Text'], override('Button Text', "Button Text ".concat(statusButtonOpen)))), /*#__PURE__*/_react["default"].createElement(_widgets.Icon, override('Button Icon', "Button Icon ".concat(statusButtonOpen)))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, styles.Wrapper, styles["Wrapper ".concat(statusOpen)], override('Wrapper', "Wrapper ".concat(statusOpen))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    onPointerDown: onClose
  }, styles.Overlay, styles["Overlay ".concat(statusOpen)], override('Overlay', "Overlay ".concat(statusOpen)))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, styles.Content, styles["Content ".concat(statusOpen)], override('Content', "Content ".concat(statusOpen))), /*#__PURE__*/_react["default"].createElement(_widgets.Icon, _extends({
    onPointerDown: onClose
  }, styles.Cross, override('Cross'))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, styles.Children, override('Children', "Children ".concat(statusOpen)), {
    display: isEmpty ? 'none' : undefined
  }), children), isEmpty && /*#__PURE__*/_react["default"].createElement(_ComponentNotice["default"], {
    message: "Drag any component here"
  }))));
};

Object.assign(MobileSidePanel, {
  title: 'Mobile side panel',
  description: {
    en: 'Container to hide menu or any other content in the mobile version of the site',
    ru: 'Контейнер для скрытия меню или любого другого контента в мобильной версии сайта'
  },
  propInfo: _props.propInfo,
  defaultProps: _props.defaultProps,
  overrides: _props.overrides
});
var _default = MobileSidePanel;
exports["default"] = _default;